import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import axios from "axios";
import { useBasket } from '../../context/BasketContext';
import { Riple } from "react-loading-indicators";
import { API_BASE_URL } from '../../constants/api';
const EventVehicleList = () => {

    const { eventId } = useParams();

    const { addToBasket } = useBasket();
    const navigate = useNavigate();
    const [showFilters, setShowFilters] = useState(true);
    const [selectedFilter, setSelectedFilter] = useState('all-vehicles');
    const [filters, setFilters] = useState({
        vehicleType: '',
        transmission: '',
        fuelType: '',
        manufacturer: '',
        priceRange: '',
        features: [],
        selectedDate: ''
    });

    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [eventDetails, setEventDetails] = useState(null);
    const [availableDates, setAvailableDates] = useState([]);

    useEffect(() => {
        // Initialize Bootstrap components when component mounts
        initBootstrapComponents();
        
        // Fetch event details first; vehicles are fetched once a date is selected
        fetchEventDetails();
    }, []);

    // Fetch vehicles/slots for the selected day
    useEffect(() => {
        if (filters.selectedDate) {
            fetchVehicles(new Date(filters.selectedDate));
        }
    }, [filters.selectedDate]);

    const fetchEventDetails = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/events/${eventId}/details?key=7678356c642c91a255471d162205e0f3`);
            const event = response.data.data;
            setEventDetails(event);
            
            // Generate array of dates between start_at and end_at, excluding past dates
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const dates = generateDateRange(new Date(event.start_at), new Date(event.end_at))
                .filter(date => date >= today);
            setAvailableDates(dates);
            
            // Set the first available date as selected by default
            if (dates.length > 0) {
                setFilters(prev => ({ ...prev, selectedDate: dates[0].toISOString() }));
            }
        } catch (error) {
            console.error('Error fetching event details:', error);
        }
    };

    const generateDateRange = (startDate, endDate) => {
        const dates = [];
        const currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            dates.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    };

    const formatDateParam = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const isSameDay = (date1, date2) => {
        return date1.getFullYear() === date2.getFullYear() &&
               date1.getMonth() === date2.getMonth() &&
               date1.getDate() === date2.getDate();
    };

    // Helper function to normalize slots data (can be array or object)
    const getSlotsArray = (slots) => {
        if (Array.isArray(slots)) {
            return slots;
        } else if (typeof slots === 'object' && slots !== null) {
            return Object.values(slots);
        }
        return [];
    };

    const isSlotInPast = (slotStartAt) => {
        const now = new Date();
        const slotTime = new Date(slotStartAt);
        const tenMinutesAgo = new Date(now.getTime() - 10 * 60 * 1000);
        return slotTime <= tenMinutesAgo;
    };

    // Slots that can still be booked for this vehicle: not already started and not taken
    const getBookableSlots = (slots) => {
        return getSlotsArray(slots).filter(slot =>
            !isSlotInPast(slot.start_at) && !slot.is_booked_for_vehicle
        );
    };

    const isFullyBooked = (vehicleData) => {
        return vehicleData.is_vehicle_fully_booked || getBookableSlots(vehicleData.slots).length === 0;
    };

    const fetchVehicles = async (date) => {

        setLoading(true);

        const dateParam = formatDateParam(date);

        axios.get( `${API_BASE_URL}/api/events/` + eventId + `/slot-bookings?key=7678356c642c91a255471d162205e0f3&format=vehicles&vehicle_type=car&start_at=${dateParam}&end_at=${dateParam}`)
            .then(response => {

                const vehiclesArray = [];
                Object.values(response.data.data).forEach(vehicleData => {
                    vehiclesArray.push(vehicleData);
                });

                setVehicles(vehiclesArray);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching events:', error);
                setLoading(false);
            });

    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFeatureToggle = (feature) => {
        setFilters(prev => ({
            ...prev,
            features: prev.features.includes(feature)
                ? prev.features.filter(f => f !== feature)
                : [...prev.features, feature]
        }));
    };

    const handleBookTestDrive = (vehicle) => {
        // addToBasket({
        //     id: vehicle.id,
        //     name: vehicle.name,
        //     description: vehicle.description,
        //     image: vehicle.images_array[0],
        //     features: vehicle.features,
        //     // Add any other relevant vehicle data you want to store in the basket
        // });
        // navigate('/client-details-form');
        navigate('/event/' + eventId + '/vehicle/' + vehicle.id + '/availability');
    };

    const handleFilterClick = (filterId) => {
        setSelectedFilter(filterId);
    };

    console.log(loading);

    // Derive manufacturer options for the dropdown from the original vehicles list
    const manufacturerDropdownOptions = [...new Set(vehicles
        .filter(v => {
            // Handle both array and object slots
            if (Array.isArray(v.slots)) {
                return v.slots.length > 0;
            } else if (typeof v.slots === 'object' && v.slots !== null) {
                return Object.keys(v.slots).length > 0;
            }
            return false;
        })
        .map(v => v.vehicle.manufacturer?.name)
        .filter(Boolean))
    ].sort();

    const filteredVehicles = vehicles
        .filter(vehicleData => {
            const { vehicle, slots } = vehicleData;

            // Manufacturer filter (from dropdown)
            if (filters.manufacturer && vehicle.manufacturer?.name !== filters.manufacturer) {
                return false;
            }

            // Filter based on selectedFilter buttons (All, Adapted, Unadapted, etc.)
            switch (selectedFilter) {
                case 'adapted-vehicles':
                    if (!vehicle.is_adapted) return false;
                    break;
                case 'unadapted-vehicles':
                    if (vehicle.is_adapted) return false;
                    break;
                case 'available':
                    // This is covered by the slots check.
                    // If it has a more specific meaning, the condition here would change.
                    break;
                case 'electric':
                    if (vehicle.fuel_type?.name?.toLowerCase() !== 'electric') return false;
                    break;
                case 'hybrid':
                    if (vehicle.fuel_type?.name?.toLowerCase() !== 'hybrid') return false;
                    break;
                case 'petrol':
                    if (vehicle.fuel_type?.name?.toLowerCase() !== 'petrol') return false;
                    break;
                case 'diesel':
                    if (vehicle.fuel_type?.name?.toLowerCase() !== 'diesel') return false;
                    break;
                // 'all-vehicles' does not add further filtering here.
                default:
                    break;
            }

            return true; // Passes all active filters
        })
        .sort((a, b) => {
            const manufacturerA = a.vehicle.manufacturer?.name?.toLowerCase() || '';
            const manufacturerB = b.vehicle.manufacturer?.name?.toLowerCase() || '';
            return manufacturerA.localeCompare(manufacturerB);
        });



    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="bg-motability-mid-black-5 py-32 pt-lg-96 pb-lg-148">
                    <div className="container">
                        <h1 className="text-primary mb-4 mb-lg-5">
                            Select vehicle for test drive
                        </h1>

                        {/* Filters Section */}
                        <div className="bg-motability-white border border-motability-mid-black-25 rounded-4 p-4 p-lg-32 mb-4 mb-lg-5">
                            <div className="accordion" id="vehicle-filters-accordion">
                                <div className="accordion-item border-0">
                                    <h6 className="accordion-header">
                                        <button 
                                            className={`accordion-button w-fit-content flex-row-reverse p-0 gap-16 shadow-none fs-6 fw-semibold ${showFilters ? '' : 'collapsed'}`}
                                            type="button"
                                            onClick={() => setShowFilters(!showFilters)}
                                            aria-expanded={showFilters}
                                        >
                                            All filters
                                        </button>
                                    </h6>

                                    <div 
                                        className={`accordion-collapse ${showFilters ? 'show' : 'collapse'}`}
                                        id="vehicle-all-filters"
                                    >
                                        <div className="accordion-body px-0 pb-0 pt-4 pt-lg-32">
                                            <div className="row g-3 g-lg-4">
                                                <div class="col-lg-6">

                                                    <p class="text-motability-black">
                                                        Show only
                                                    </p>

                                                    <div class="select-buttons single-button-only select-buttons-primary d-flex align-items-center flex-wrap column-gap-2 row-gap-3 mb-4 mb-lg-5" id="vehicle-filters-categories">

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-all-vehicles" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'all-vehicles' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('all-vehicles')}
                                                        >
                                                            All vehicles
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-adapted-vehicles" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'adapted-vehicles' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('adapted-vehicles')}
                                                        >
                                                            Adapted vehicles
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-unadapted-vehicles" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'unadapted-vehicles' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('unadapted-vehicles')}
                                                        >
                                                            Unadapted vehicles
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-available" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'available' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('available')}
                                                        >
                                                            All Fuel Types
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-electric" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'electric' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('electric')}
                                                        >
                                                            Electric
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-hybrid" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'hybrid' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('hybrid')}
                                                        >
                                                            Hybrid
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-petrol" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'petrol' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('petrol')}
                                                        >
                                                            Petrol
                                                        </button>

                                                        <button 
                                                            type="button" 
                                                            id="vehicle-filters-diesel" 
                                                            class={`select-btn btn rounded-pill fs-15 py-2 shadow-none ${selectedFilter === 'diesel' ? 'selected' : 'bg-motability-light-orange'}`}
                                                            onClick={() => handleFilterClick('diesel')}
                                                        >
                                                            Diesel
                                                        </button>

                                                    </div>

                                                    <p class="text-motability-black">
                                                        Manufacturer
                                                    </p>

                                                    <select 
                                                        name="manufacturer" 
                                                        id="vehicle-filters-manufacturer" 
                                                        className="form-select f-input-lg blue-select-dropdown w-lg-60 border-motability-mid-black-40 shadow-motability-mid-black-12-inset" 
                                                        value={filters.manufacturer}
                                                        onChange={handleFilterChange}
                                                    >
                                                        <option value="">All Manufacturers</option>
                                                        {manufacturerDropdownOptions.map(name => (
                                                            <option key={name} value={name}>{name}</option>
                                                        ))}
                                                    </select>

                                                    <p class="text-motability-black mt-4">
                                                        Date
                                                    </p>

                                                    <div class="d-flex align-items-center flex-wrap column-gap-2 row-gap-3">
                                                        {availableDates.map((date, index) => (
                                                            <button 
                                                                key={index}
                                                                type="button" 
                                                                className={`btn rounded-pill fs-15 py-2 shadow-none ${
                                                                    filters.selectedDate === date.toISOString() ? 'btn-primary text-white' : 'bg-motability-light-orange'
                                                                }`}
                                                                onClick={() => setFilters(prev => ({ ...prev, selectedDate: date.toISOString() }))}
                                                            >
                                                                {formatDate(date)}
                                                            </button>
                                                        ))}
                                                    </div>

                                                </div>

                                                {/* <div class="col-lg-6">

                                                    <p class="text-motability-black">
                                                        Only show vehicles that are available
                                                    </p>

                                                    <div class="d-flex align-items-xl-center gap-3 flex-column flex-xl-row">

                                                        <div class="d-flex align-items-center gap-3">

                                                            <span>
                                                                From
                                                            </span>

                                                            <select name="vehicle-filters-from-time" id="vehicle-filters-from-time" class="form-select f-input-lg bg-img-none w-88 px-2 border-motability-mid-black-40 shadow-motability-mid-black-12-inset text-center" required>
                                                                <option value="" disabled selected>--:--</option>
                                                                <option value="09:00">09:00</option>
                                                                <option value="09:15">09:15</option>
                                                                <option value="09:30">09:30</option>
                                                                <option value="09:45">09:45</option>
                                                                <option value="10:00">10:00</option>
                                                                <option value="10:15">10:15</option>
                                                                <option value="10:30">10:30</option>
                                                                <option value="10:45">10:45</option>
                                                                <option value="11:00">11:00</option>
                                                                <option value="11:15">11:15</option>
                                                                <option value="11:30">11:30</option>
                                                                <option value="11:45">11:45</option>
                                                                <option value="12:00">12:00</option>
                                                                <option value="12:15">12:15</option>
                                                                <option value="12:30">12:30</option>
                                                                <option value="12:45">12:45</option>
                                                                <option value="13:00">13:00</option>
                                                                <option value="13:15">13:15</option>
                                                                <option value="13:30">13:30</option>
                                                                <option value="13:45">13:45</option>
                                                                <option value="14:00">14:00</option>
                                                                <option value="14:15">14:15</option>
                                                                <option value="14:30">14:30</option>
                                                                <option value="14:45">14:45</option>
                                                                <option value="15:00">15:00</option>
                                                                <option value="15:15">15:15</option>
                                                                <option value="15:30">15:30</option>
                                                                <option value="15:45">15:45</option>
                                                                <option value="16:00">16:00</option>
                                                                <option value="16:15">16:15</option>
                                                                <option value="16:30">16:30</option>
                                                                <option value="16:45">16:45</option>
                                                                <option value="17:00">17:00</option>
                                                                <option value="17:15">17:15</option>
                                                                <option value="17:30">17:30</option>
                                                                <option value="17:45">17:45</option>
                                                                <option value="18:00">18:00</option>
                                                                <option value="18:15">18:15</option>
                                                                <option value="18:30">18:30</option>
                                                                <option value="18:45">18:45</option>
                                                                <option value="19:00">19:00</option>
                                                                <option value="19:15">19:15</option>
                                                                <option value="19:30">19:30</option>
                                                                <option value="19:45">19:45</option>
                                                                <option value="20:00">20:00</option>
                                                                <option value="20:15">20:15</option>
                                                                <option value="20:30">20:30</option>
                                                                <option value="20:45">20:45</option>
                                                            </select>
    
                                                            <span>
                                                                to
                                                            </span>

                                                            <select name="vehicle-filters-to-time" id="vehicle-filters-to-time" class="form-select f-input-lg bg-img-none w-88 px-2 border-motability-mid-black-40 shadow-motability-mid-black-12-inset text-center" required>
                                                                <option value="" disabled selected>--:--</option>
                                                                <option value="09:00">09:00</option>
                                                                <option value="09:15">09:15</option>
                                                                <option value="09:30">09:30</option>
                                                                <option value="09:45">09:45</option>
                                                                <option value="10:00">10:00</option>
                                                                <option value="10:15">10:15</option>
                                                                <option value="10:30">10:30</option>
                                                                <option value="10:45">10:45</option>
                                                                <option value="11:00">11:00</option>
                                                                <option value="11:15">11:15</option>
                                                                <option value="11:30">11:30</option>
                                                                <option value="11:45">11:45</option>
                                                                <option value="12:00">12:00</option>
                                                                <option value="12:15">12:15</option>
                                                                <option value="12:30">12:30</option>
                                                                <option value="12:45">12:45</option>
                                                                <option value="13:00">13:00</option>
                                                                <option value="13:15">13:15</option>
                                                                <option value="13:30">13:30</option>
                                                                <option value="13:45">13:45</option>
                                                                <option value="14:00">14:00</option>
                                                                <option value="14:15">14:15</option>
                                                                <option value="14:30">14:30</option>
                                                                <option value="14:45">14:45</option>
                                                                <option value="15:00">15:00</option>
                                                                <option value="15:15">15:15</option>
                                                                <option value="15:30">15:30</option>
                                                                <option value="15:45">15:45</option>
                                                                <option value="16:00">16:00</option>
                                                                <option value="16:15">16:15</option>
                                                                <option value="16:30">16:30</option>
                                                                <option value="16:45">16:45</option>
                                                                <option value="17:00">17:00</option>
                                                                <option value="17:15">17:15</option>
                                                                <option value="17:30">17:30</option>
                                                                <option value="17:45">17:45</option>
                                                                <option value="18:00">18:00</option>
                                                                <option value="18:15">18:15</option>
                                                                <option value="18:30">18:30</option>
                                                                <option value="18:45">18:45</option>
                                                                <option value="19:00">19:00</option>
                                                                <option value="19:15">19:15</option>
                                                                <option value="19:30">19:30</option>
                                                                <option value="19:45">19:45</option>
                                                                <option value="20:00">20:00</option>
                                                                <option value="20:15">20:15</option>
                                                                <option value="20:30">20:30</option>
                                                                <option value="20:45">20:45</option>
                                                            </select>

                                                        </div>

                                                        <button type="button" class="bg-transparent border-0 w-fit-content shadow-none text-primary p-0 text-decoration-underline">
                                                            Update results
                                                        </button>

                                                    </div>

                                                </div> */}

                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                        </div>

                        {/* Vehicles List */}
                        <div className="row g-4">
                            {loading ? (
                                <div className="col-12 text-center">
                                    <Riple color="#32cd32" size="medium" text="" textColor="" />
                                </div>
                            ) : filteredVehicles.length === 0 ? (
                                <div className="col-12 text-center">
                                    <p>No vehicles found matching your criteria.</p>
                                </div>
                            ) : (
                                filteredVehicles.map((vehicle, index) => (
                                    <div key={vehicle.id} className="col-6 col-md-4 col-lg-3">
                                        <div 
                                            className="vehicle-card card border-motability-mid-black-20 rounded-4 h-100 cursor-pointer"
                                            onClick={() => {
                                                if (isFullyBooked(vehicle)) {
                                                    return;
                                                }

                                                // Check if vehicle still has a bookable slot on the selected date
                                                if (filters.selectedDate) {
                                                    const selectedDate = new Date(filters.selectedDate);
                                                    const hasSlotOnSelectedDate = getBookableSlots(vehicle.slots).some(slot => {
                                                        const slotDate = new Date(slot.start_at);
                                                        return isSameDay(slotDate, selectedDate);
                                                    });

                                                    if (!hasSlotOnSelectedDate) {
                                                        return;
                                                    }
                                                }

                                                handleBookTestDrive(vehicle.vehicle);
                                            }}
                                        >
                                            <div className="d-flex align-items-center justify-content-center bg-motability-lighter-blue p-3 rounded-top-4 position-relative">
                                                <div className="ratio ratio-16x9">
                                                    <img
                                                        src={vehicle.vehicle.images_array[0]}
                                                        alt={vehicle.vehicle.name}
                                                        className="img-fluid object-fit-contain object-position-center h-100"
                                                        decoding="async"
                                                        loading="lazy"
                                                        fetchpriority="low"
                                                    />
                                                </div>
                                            </div>

                                            <div className="card-body p-3 pb-20">
                                                <h3 className="vehicle-card-title h6 text-primary fs-xl-21 lh-125 mb-3 ff-f37-maulstick">
                                                    {vehicle.vehicle.manufacturer?.name} {vehicle.vehicle.model}
                                                </h3>

                                                {(() => {
                                                    if (isFullyBooked(vehicle)) {
                                                        return (
                                                            <div className="mb-3">
                                                                <span className="badge bg-danger text-white px-2 py-1 rounded-pill ff-f37-maulstick">
                                                                    Fully Booked
                                                                </span>
                                                            </div>
                                                        );
                                                    }
                                                    
                                                })()}

                                                <ul className="vehicle-features list-unstyled d-flex align-items-center flex-wrap gap-2 mb-2">
                                                    {vehicle.vehicle.fuel_type && <li className="badge bg-motability-light-green text-dark px-2 py-1 rounded-pill ff-f37-maulstick">
                                                        {vehicle.vehicle.fuel_type?.name}
                                                    </li>}
                                                    {vehicle.vehicle.transmission && <li className="badge bg-motability-light-orange text-dark px-2 py-1 rounded-pill ff-f37-maulstick">
                                                        {vehicle.vehicle.transmission?.name}
                                                    </li>}
                                                    {vehicle.vehicle.seats && <li className="badge bg-motability-light-orange text-dark px-2 py-1 rounded-pill ff-f37-maulstick">
                                                        {vehicle.vehicle.seats?.name} seats
                                                    </li>}
                                                    {vehicle.vehicle.doors && <li className="badge bg-motability-light-orange text-dark px-2 py-1 rounded-pill ff-f37-maulstick">
                                                        {vehicle.vehicle.doors?.name} doors
                                                    </li>}
                                                    {vehicle.vehicle.misc_tags.forEach((tag) => {
                                                        <li className="badge bg-motability-light-orange text-dark px-2 py-1 rounded-pill ff-f37-maulstick">
                                                            {tag}
                                                        </li>
                                                    })}
                                                </ul>

                                                {vehicle.vehicle.adaptations.length === 0 ? (
                                                    <small className="d-block text-motability-black fw-medium mt-3 ff-f37-maulstick">
                                                        Unadapted Vehicle
                                                    </small>
                                                ) : (
                                                    <div className="mt-3">
                                                        <small className="d-block text-motability-black fw-medium ff-f37-maulstick mb-2">
                                                            Adaptations:
                                                        </small>
                                                        <ul className="list-unstyled m-0">
                                                            {vehicle.vehicle.adaptations.map((adaptation, index) => (
                                                                <li key={index} className="text-motability-black small ff-f37-maulstick">
                                                                    {adaptation.name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                        <Link to="/event-select" className="d-inline-block fw-medium text-decoration-none mt-4 mt-lg-5">
                            ‹ <span className="d-inline-block text-decoration-underline">Back to test drive booking</span>
                        </Link>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default EventVehicleList;
